import ApiService from "../api/api.service";
import { VoCFileUploadAPIRequest, VoCFileUploadAPIResponse } from "./vocFiles.api.types";
import VocFilesEndpoints from "./vocFiles.endpoint";

export const VoCFilesService = {
  async postVoCFileAndGetPresignedURL(request_data: VoCFileUploadAPIRequest): Promise<string> {
    const { data } = await ApiService.fetchData<VoCFileUploadAPIRequest, VoCFileUploadAPIResponse>({
      url: VocFilesEndpoints.POST_VOC_FILE,
      method: "POST",
      data: request_data,
    });
    return data.presignedUrl;
  },
};
